import script from "./BaseClose.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseClose.vue?vue&type=script&setup=true&lang=js"

import "./BaseClose.vue?vue&type=style&index=0&id=427e22ec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427e22ec"]])

export default __exports__